import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  AppInput,
  AppModal,
  AppMultiSelect,
  AppTextArea,
} from '@/layout/AppComponents';
import axios from 'axios';
import { Formik } from 'formik';
import * as Yup from 'yup';
import * as currentPageAction from '../../../../../../store/actions/currentPageAction';
import { axiosPath } from '../../../../../../routing/helpers/router';
import Translator from '../../../../../components/helpers/Translator';
import useIsMounted from '../../../../../components/hooks/useIsMounted';
import errorHandler from '@/layout/components/error/ErrorHandler';
import TotalEnergiesRiskProcessSelect from '../../../../../components/form/Selects/TotalEnergiesRiskProcessSelect';
import ResponsibleSelect from '../../../../../components/form/Selects/ResponsibleSelect';

export default function ProcessAdd({ showModal, setShowModal }) {
  const { moduleBridgeHex } = useParams();
  const isMounted = useIsMounted();
  const dispatch = useDispatch();
  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Requerido'),
    shortName: Yup.string().required('Requerido'),
    parentProcess: Yup.number()
      .nullable()
      .when([], {
        is: () => showModal === 'subprocess',
        then: (schema) => schema.required('Requerido'),
        otherwise: (schema) => schema.notRequired(),
      }),
  });

  const handleSave = useCallback(
    async (values) =>
      axios
        .post(axiosPath("api_r_user_module_totalEnergiesRisk_process_add"), {
          moduleBridgeHex,
          ...values,
        })
        .then(() => {
          if (isMounted.current) {
            dispatch(currentPageAction.change("loading", true));
            setShowModal(undefined);
          }
        })
        .catch((e) => dispatch(errorHandler(e))),
    [moduleBridgeHex]
  );

  return (
    <AppModal
      show={showModal !== undefined}
      size="lg"
      title={`Añadir ${showModal === 'process' ? 'proceso' : 'subproceso'}`}
      onClose={() => setShowModal(undefined)}
    >
      <Formik
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={validationSchema}
        initialValues={{
          name: '',
          shortName: '',
          description: '',
          parentProcess: null,
          responsibles: [],
        }}
        onSubmit={handleSave}
      >
        {({ setFieldValue, handleSubmit, values, errors, isSubmitting }) => (
          <form onSubmit={handleSubmit}>
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-6">
                  <AppInput
                    title="Nombre"
                    value={values?.name}
                    error={errors.name}
                    onChange={(opt) => setFieldValue('name', opt)}
                    required
                  />
                </div>
                <div className="col-lg-6">
                  <AppInput
                    title="Nombre corto"
                    value={values?.shortName}
                    error={errors.shortName}
                    onChange={(opt) => setFieldValue('shortName', opt)}
                    required
                  />
                </div>
                {showModal === 'process' && (
                  <div className="col-lg-12">
                    <ResponsibleSelect
                      value={values.responsibles}
                      error={errors?.responsibles}
                      onHandleChange={(opt) =>
                        setFieldValue('responsibles', opt)
                      }
                      apiCall="api_r_user_module_totalEnergiesRisk_control_getResponsibles"
                      hasSearchBox
                      isClearable
                    />
                  </div>
                )}
                {showModal === 'subprocess' && (
                  <div className="col-lg-12">
                    <TotalEnergiesRiskProcessSelect
                      value={values?.parentProcess}
                      error={errors?.parentProcess}
                      onHandleChange={(opt) => {
                        setFieldValue('parentProcess', opt);
                      }}
                      required
                      hasSearchBox
                      onlyParents
                    />
                  </div>
                )}
                <div className="col-lg-12">
                  <AppTextArea
                    title="Descripción"
                    value={values.description}
                    onChange={(value) => setFieldValue('description', value)}
                    error={errors.description}
                  />
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-12">
                <button
                  type="submit"
                  className="btn btn-sm btn-success float-right"
                  disabled={isSubmitting}
                >
                  Crear
                </button>
                <button
                  type="button"
                  onClick={() => setShowModal(undefined)}
                  className="btn btn-sm btn-outline-danger float-right mr-2"
                >
                  Cancelar
                </button>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </AppModal>
  );
}
